// @flow

import React, { Component } from 'react';
import { get } from 'lodash';

import { getGravatarUrl } from '@zapier/common-utils';

import AvatarOrTeamLogo from 'web-ssr/app/common/components/AvatarOrTeamLogo/AvatarOrTeamLogo';
import { HeaderContext } from 'web-ssr/app/common/components/ContentHeader/HeaderProvider';

type Props = {
  accountId: number,
};

type State = {};

class AvatarOrTeamLogoContainer extends Component<Props, State> {
  render() {
    const { accountId } = this.props;

    return (
      <HeaderContext.Consumer>
        {context => {
          const accounts = get(context, ['data', 'accounts', 'objects'], []);
          const profiles = get(context, ['data', 'profiles', 'objects'], []);

          const account = accounts.find(obj => {
            return obj.id === accountId;
          });
          const profile = profiles.find(obj => {
            return account.owner.id === obj.id;
          });
          const isOrWasTeam =
            account.is_team_account && !!account.team_account_end_date;

          const logoChoiceOrUrl = account.logo_choice
            ? `/images/team-account-wizard/illustrations/${account.logo_choice}`
            : account.logo_url;

          const url = isOrWasTeam
            ? logoChoiceOrUrl
            : getGravatarUrl(profile.email_hash);

          const name = isOrWasTeam
            ? account.name
            : `${profile.first_name} ${profile.last_name}`.trim() ||
              profile.email;
          return (
            <AvatarOrTeamLogo isTeam={isOrWasTeam} name={name} url={url} />
          );
        }}
      </HeaderContext.Consumer>
    );
  }
}

export default AvatarOrTeamLogoContainer;
